<template>
  <section
    id="team-intro"
    class="team-intro section-bg"
    @click="onOpenTeamPage"
  >
    <!-- <h2 class="title1">团队介绍</h2> -->
    <img src="../../assets/images/topline.png" class="topline" />

    <img src="../../assets/images/experts/Experts.png" class="imgtitle" />
    <div class="team-numbers">
      <div class="ex-warp" v-for="(item2, index) in hotImgList" :key="index">
        <div class="ex-img">
          <img :src="`${filePreview}${item2.cover}`" />
        </div>
        <div class="ex-text">
          <h4 class="h4">{{ item2.expert_name }}</h4>
          <p class="ex-school">{{ item2.work_unit }}</p>
          <p class="ex-name">{{ item2.nationality }}</p>
        </div>
      </div>
    </div>
    <div class="team-num">
      <div class="ex-warp" v-for="(item, index) in imgList" :key="index">
        <div class="ex-img">
          <img :src="`${filePreview}${item.cover}`" />
        </div>
        <div class="ex-text">
          <h4 class="h4">{{ item.expert_name }}</h4>
          <p class="ex-school">{{ item.work_unit }}</p>
          <p class="ex-name">{{ item.nationality }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return {
      filePreview: `${window._CONFIG['filePreview']}?fileId=`,
      imgList: [],
      hotImgList: []
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    onOpenTeamPage() {
      window.open('https://once.xmu.edu.cn/about/Organization.htm', '_blank');
    },
    getInfo() {
      let url = `${window._CONFIG['domianURL']}xmu/index/getData/ef2911fc50824aea814b6fbea82853dc`;
      // let token = JSON.parse(localStorage.getItem("pro__Access-Token")).value;
      let params = {
        pageNo: 1,
        pageSize: 999,
        is_publish: 1,
        column: 'id',
        order: 'desc',
        superQueryMatchType: 'and'
      };
      this.$axios({
        method: 'get',
        url: url,
        params: params,
        headers: {}
        // data: sendobj,
      }).then(res => {
        let data = res.data.result.records;
        data.forEach(item => {
          if (item.is_publish == 1) {
            this.imgList.push({
              cover: item.cover,
              expert_name: item.expert_name,
              nationality: item.nationality,
              work_unit: item.work_unit
            });
          }
        });
        this.hotImgList = this.imgList.splice(0, 2);
        this.imgList = this.imgList.splice(0, 4);
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.ex-warp {
  transition: 0.4s;
  cursor: pointer;
  overflow: hidden;
  // background: #003a7e;
  background-image: url('../../assets/images/activites-bg.png');
  /* height: 100%; */
  box-shadow: 0 5px 16px 0 rgb(0 0 0 / 15%);
  margin-bottom: 50px;

  .ex-img {
    cursor: pointer;
    padding: 10px;
    position: relative;
    margin: 0 auto;
  }

  .ex-text {
    padding-bottom: 20px;
    text-align: center;
    // padding: 0.6rem;
    color: #003376;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .h4 {
    font-size: 1.25rem;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    color: #003376;
  }
}

.ex-warp:hover {
  transform: translateY(-8px) scale(1.01);
  box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.5);
}

.team-numbers {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  -moz-column-gap: 20px;
  column-gap: 20px;
  margin-top: 30px;
}

.team-num {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  -moz-column-gap: 20px;
  column-gap: 20px;
}

.team-number:nth-child(2n-1) {
  // margin-top: 30px;
  padding-bottom: 0;
  height: 390px;

  .img {
    // box-shadow: 2px 18px 10px rgb(0 0 0 / 30%)
  }
}

.team-number:nth-child(2n) {
  margin-bottom: 30px;
  padding-bottom: 0;
  height: 390px;

  .img {
    // box-shadow: 2px 18px 10px rgb(0 0 0 / 30%)
  }
}

.imgtitle {
  width: 200px;
  height: 70px;
}

.topline {
  width: 1px;
  height: 50px;
  margin: 0 auto;
  margin-bottom: 10px;
}

.ex-school {
  width: 200px;
  margin-top: 10px;
  font-family: 'pala';
  font-weight: 400;
  color: #003376;
  line-height: 24px;
}

.ex-name {
  font-family: 'pala';
  font-weight: 400;
  color: #003376;
  line-height: 24px;
}
</style>
